import {useEffect, useRef} from "react";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {Button, Link} from "@mui/material";
import {CopyAll, GpsFixed} from "@mui/icons-material";
import useAlert from "../../../../use/useAlert";
import useClipboard from "../../../../use/useClipboard";
import useClientRepository from "../../../../repository/b2c/useClientRepository";
import Typography from "@mui/material/Typography";
import useAddressRepository from "../../../../repository/b2c/useAddressRepository";

export default function ({orderId, clientId}) {
    const alert = useAlert();
    const clipboard = useClipboard();
    const clientRepository = useClientRepository();
    const addressRepository = useAddressRepository();
    /** @type Address */
    const address = addressRepository.findOneByOrderId(orderId).select();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();
    const googleMapLink = useRef();

    useEffect(() => {
        addressRepository.findOneByOrderId(orderId).exec(false);
        clientRepository.findOneById(clientId).exec();
    }, []);

    const handleOpenMap = () => {
        googleMapLink.current.click();
    }

    const handleCopyCoordinate = () => {
        clipboard(`${address.getLat()},${address.getLng()}`);

        alert.success("Copié !");
    }

    const handleCopyAddress = () => {
        clipboard(`${address.getLine1()} ${isNull(address.getLine2()) ? "" : address.getLine2()} ${isNull(address.getLine3()) ? "" : address.getLine3()}, ${address.getPostcode()} ${address.getCity()}`);

        alert.success("Copié !");
    }

    if (isNull(address) || isNull(client)) return null;

    return (
        <>
            <Typography textAlign="center" fontWeight={"bold"} variant="h5">
                {client.getName()}
            </Typography>
            <Typography mt={5} textAlign="center">
                {address.getLine1()} {address.getLine2()} {address.getLine3()}, <br/>{address.getPostcode()} {address.getCity()}
            </Typography>
            <Box mt={10} display="flex" justifyContent="center">
                <Button
                    startIcon={<GpsFixed/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleOpenMap}
                    data-test="button-open-map"
                    fullWidth={true}
                >
                    Ouvrir mon GPS
                </Button>
            </Box>
            <Box mt={5} display="flex" justifyContent="center">
                <Button
                    startIcon={<CopyAll/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleCopyCoordinate}
                    fullWidth={true}
                >
                    Copier les coordonnées GPS
                </Button>
            </Box>
            <Box mt={5} display="flex" justifyContent="center">
                <Button
                    startIcon={<CopyAll/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleCopyAddress}
                    fullWidth={true}
                >
                    Copier l'adresse
                </Button>
            </Box>
            <Link
                ref={googleMapLink}
                href={`https://www.google.com/maps/dir/?api=1&origin=Current%20Location&destination=${address.getLat()},${address.getLng()}`}
                target={"_blank"}
                color={"inherit"}
                underline={"none"}
            />
        </>
    )
}